import PaySuccess from '../component/paySuccess';

export default (props) => {
  return <PaySuccess {...props} />;
};
